import { render } from "./PatientProfile.vue?vue&type=template&id=1ce8705e&scoped=true&ts=true"
import script from "./PatientProfile.vue?vue&type=script&lang=ts"
export * from "./PatientProfile.vue?vue&type=script&lang=ts"

import "./PatientProfile.vue?vue&type=style&index=0&id=1ce8705e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce8705e"]])

export default __exports__